import { AudioManager } from '../../../core/AudioManager';
import { PositionalOptions } from '../../../core/AudioManager.types';
import { Character } from '../../Character';

export class HurtCarAudio {
    static readonly PRELOAD = [
        '../assets/sounds/man_hurt_car.mp3',
        '../assets/sounds/woman_hurt_car.mp3',
    ] as const;

    private static readonly OPTIONS: PositionalOptions = { volume: 1, loop: false, refDistance: 15 };

    constructor(
        private readonly audioManager: AudioManager,
        private readonly character: Character,
    ) {}

    public play(): void {
        const src = this.character.gender === 'woman'
            ? HurtCarAudio.PRELOAD[1]
            : HurtCarAudio.PRELOAD[0];
        this.audioManager.playPositional(src, this.character, HurtCarAudio.OPTIONS);
    }
}
